import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tabsRoot: {
    marginBottom: theme.spacing(3)
  },
  card: {
    marginBottom: theme.spacing(3)
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&:last-child' :{
      paddingBottom: 0
    }
  },
  footer: {
    textAlign: 'center',
  },
  checkboxText: {
    fontSize:14,
    fontWeight: 'normal',
    color: theme.palette.text.secondary,
  },
  toggleBtnGroup: {
    display: 'flex !important',
    '& > button': {
      flex: 1
    }
  },
  infoAlert: {
    background: 'rgba(42, 126, 187, 0.1)',
    '& .MuiAlert-icon': {
      color: '#547FF6',
    }
  },
  infoText: {
    fontSize:12,
    color:theme.palette.info.text
  },
  activityFormContainer: {
    marginTop: theme.spacing(5)
  },
  formRoot: {
    marginLeft: theme.spacing(3)
  }
}));

export default useStyles;
